import { render, staticRenderFns } from "./cookie-policy.view.vue?vue&type=template&id=3c1912c5&scoped=true&"
import script from "./cookie-policy.view.vue?vue&type=script&lang=ts&"
export * from "./cookie-policy.view.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-policy.view.vue?vue&type=style&index=0&id=3c1912c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1912c5",
  null
  
)

export default component.exports